{
    "Title": "Wachtrijen beheren",
    "ManageQueuesDescriptionTitle": "Beschrijving",
    "ManageQueuesCQConfigurationsTitle": "CQ-configuraties",
    "ManageQueuesResourceAccountsTitle": "Resource-accounts",
    "ManageQueuesMonitoringStatusTitle": "Monitoringstatus",
    "ManageQueueFiltersTitle": "Filters",
    "ManageQueueCallMonitoringHistoric": "Historisch",
    "ManageQueueCallMonitoringRealTime": "Real-time",
    "ManageQueueCallMonitoringRealTimeForced": "Real-time (gedwongen)",
    "ManageQueueCallMonitoringUnknown": "Onbekend",
    "ManageQueueCallCQConfigurationCompatible": "Verenigbaar",
    "ManageQueueCallCQConfigurationIncompatible": "Onverenigbaar",
    "ManageQueuesQueueFilterAll": "Alle wachtrijen",
    "ManageQueuesFilterCompatible": "Compatibele wachtrijen",
    "ManageQueuesFilterIncompatible": "Incompatibele wachtrijen",
    "ManageQueue_DisableEnableRealtime_Confirm": "Bevestigen",
    "ManageQueue_DisableEnableRealtime_Cancel": "Annuleren",
    "ManageQueue_MonitorAllMessage": "Weet u zeker dat u realtime monitoring voor alle wachtrijen wilt inschakelen?",
    "ManageQueue_UnmonitorAllMessage": "Weet u zeker dat u realtime monitoring voor alle wachtrijen wilt uitschakelen?",
    "ManageQueue_Loading_Monitoring_All": "Realtime monitoring voor alle wachtrijen inschakelen",
    "ManageQueue_Loading_Unmonitoring_All": "Realtime monitoring voor alle wachtrijen uitschakelen",
    "ManageQueue_Pending_Queue_Disabling": "Monitoring uitschakelen...",
    "ManageQueue_Pending_Queue_Enabling": "Monitoring inschakelen...",
    "ManageQueue_Disable_RT_Popper": "Realtime monitoring op alle wachtrijen uitschakelen",
    "ManageQueue_Enable_RT_Popper": "Realtime monitoring inschakelen voor alle wachtrijen",
    "ManageQueues_Not_Found_Error": "Er zijn geen wachtrijen gevonden die aan die zoekopdracht voldoen",
    "NAME": "ManageQueues",
    "ManageQueues_Linkage_Title": "Gekoppelde resourceaccounts \/ spraakapps",
    "ManageQueues_Linkage_Help": "Klik op Help om te ontdekken hoe u resource-accounts opnieuw kunt koppelen",
    "ManageQueues_Linkage_Types_CallQueue": "Resourceaccount '**{}**' wordt gebruikt voor uitzonderingsafhandeling van '**{}**' in oproepwachtrij '**{}**'.",
    "ManageQueues_Linkage_Types_AutoAttendant": "Resourceaccount '**{}**' wordt gebruikt voor optie '**{}**' van '**{}**' op Auto Attendant '**{}**'.",
    "ManageQueues_Linkage_Types_Policy": "Resourceaccount '**{}**' wordt gebruikt binnen beleid '**{}**' van het type '**{}**'.",
    "ManageQueues_Linkage_CallQueue_Exceptions_overflow": "Overloop",
    "ManageQueues_Linkage_CallQueue_Exceptions_timeout": "Time-out",
    "ManageQueues_Linkage_CallQueue_Exceptions_noagent": "Geen agent",
    "ManageQueues_Linkage_CallQueue_Exceptions_obo": "Namens",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_businesshours": "Kantooruren",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_afterhours": "Na sluitingstijd",
    "ManageQueues_Linkage_AutoAttendant_Menu_Options_holiday": "Vakantie",
    "ManageQueues_Linkage_Policy_Types_teamssharedcallingroutingpolicy": "Gedeeld oproeprouteringsbeleid",
    "ManageQueues_Linkage_Policy_Types_teamsunassignednumbertreatment ": "Behandeling van niet-toegewezen nummers",
    "ManageQueues_Linkage_Policy_Types_callinglineidentity": "Identiteit van de oproeplijn",
    "ManageQueues_Linkage_Options_automatic": "Omleiden",
    "ManageQueues_Linkage_Options_pound": "Pond",
    "ManageQueues_Linkage_Options_star": "Ster",
    "ManageQueues_Linkage_NoInfo": "Er zijn geen resourceaccountreferenties voor deze wachtrij.",
    "ManageQueues_Incompatibility_Popup_Title": "Incompatibele instellingen",
    "ManageQueues_ExchangePermission_Error": "Er is geen beheerders-\/Exchange-machtiging gevonden voor de TelSys-gebruiker. Gedeelde voicemails kunnen niet worden aangemaakt."
}